import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "lotInput",
    "beginDateInput",
    "encadrementReferenceInput",
    "encadrementReferenceMajoreInput",
    "honosMelInput",
    "honosMelProprioInput",
    "isForcedInput",
    "isForcedInputWrapper",
    "locEnPlaceInput",
  ]

  updateFieldsBasedOnBeginDateAndLot() {
    this.updateEncadrementValue()
    this.updateHonorairesMel()
  }

  updateHonorairesMel() {
    const locEnPlace = this.locEnPlaceInputTarget.value === "true"
    // On n update pas les honoraires si loc en place oui
    if (locEnPlace)
      return
    let beginDate = this.beginDateInputTarget.value
    let lotId = this.lotInputTarget["form--collection-select--component"].value

    if (!beginDate || !lotId)
      return false;

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]').content
      fetch(`/oqoro_admin/lots/${lotId}/honoraires_mel?lease_begin_date=${beginDate}`)
        .then(resp => resp.json())
        .then(data => {
          const {honoraires_frais_mise_en_location_reel, honoraires_frais_mise_en_location_proprio} = data
          this.honosMelInputTarget.value = honoraires_frais_mise_en_location_reel
          this.honosMelProprioInputTarget.value = honoraires_frais_mise_en_location_proprio
        })
    } catch (error) {
    }
  }

  updateEncadrementValue() {
    let beginDate = this.beginDateInputTarget.value
    let lotId = this.lotInputTarget["form--collection-select--component"].value

    if (!beginDate || !lotId)
      return false;

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]').content
      fetch(`/admin/lots/${lotId}/property_id`)
        .then(resp => resp.json())
        .then(data => {
          const {property_id} = data
          fetch(`/oqoro_admin/properties/${property_id}/encadrement_value`, {
            method: "POST",
            body: JSON.stringify({lease_date: beginDate}),
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": csrfToken,
            },
            credentials: "same-origin",
          })
            .then(resp => resp.json())
            .then(data => {
              const {reference_value, reference_value_majore} = data
              this.encadrementReferenceInputTarget.value = reference_value
              this.encadrementReferenceMajoreInputTarget.value = reference_value_majore
            })
        })
    } catch (error) {
    }
  }

  toggleIsForced(e) {
    let locEnPlaceValue = e.target.value === "true" ? true : false;
    if (locEnPlaceValue) {
      if (this.isForcedInputWrapperTarget.classList.contains("hidden")) {
        this.isForcedInputWrapperTarget.classList.remove("hidden");
      }
    } else {
      if (!this.isForcedInputWrapperTarget.classList.contains("hidden")) {
        this.isForcedInputWrapperTarget.classList.add("hidden");
      }
      this.isForcedInputTarget.checked = false;
    }
  }

  locEnPlaceChanged(e) {
    const locEnPlace = e.currentTarget.value
    if (locEnPlace === "true") {
      // Set honos to zeros
      this.honosMelInputTarget.value = 0
      this.honosMelProprioInputTarget.value = 0
    } else {
      // Recalculate honos
      this.updateHonorairesMel()
    }
  }

  changeOfEndDate(e) {
    const thisElem = e.currentTarget;
    const parentElem = thisElem.closest('.oq-input-group').querySelector('.relative');
    let warningSpan = parentElem.querySelector('#end-date-warning-span');
    if (typeof(warningSpan) != 'undefined' && warningSpan != null)
        warningSpan.remove();
    if (!parentElem.classList.contains('flex'))
      parentElem.classList.add('flex', 'items-center', 'space-x-2');
    let value = e.currentTarget.value;
    if (value === null || value === '' || typeof(value) == 'undefined')
      return;
    let errorSpan = document.createElement('span');
    errorSpan.setAttribute("id", "end-date-warning-span");
    errorSpan.classList.add('text-xs', 'text-danger');

    const inputDate = new Date(value);
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let inThirtyDays = new Date();
    inThirtyDays.setDate(today.getDate() + 30);
    inThirtyDays.setHours(0, 0, 0, 0);

    if (inputDate <= today) {
      errorSpan.innerHTML = "Attention, la date sélectionnée est dans le passé !";
      parentElem.appendChild(errorSpan);
    } else if (inputDate >= today && inputDate < inThirtyDays) {
      errorSpan.innerHTML = "Attention, la date sélectionnée est dans moins de 30 jours !";
      parentElem.appendChild(errorSpan);
    }
  }
}
